<template>
  <RegistrationMenu 
    v-if="$route.name == 'RegisterEvent' || $route.name == 'UnPaidRegistration'" 
    @changeDMenu="$emit('changeDMenu')"
    @loadOptionsRegistration="loadOptionsRegistration"
  />  
</template>

<script>
import { mapState } from "vuex";
import RegistrationMenu from "@/components/topmenu/RegistrationMenu";

export default {
  components: {
      RegistrationMenu
  },
  computed: {
    ...mapState(["root"]),
  },
  methods: {
    loadOptionsRegistration(options) {
      this.$emit("loadOptionsRegistration", options);
    }
  }
};
</script>